import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=220dbc9e&scoped=true&"
import script from "./ProductCategory.vue?vue&type=script&async=true&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=220dbc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dbc9e",
  null
  
)

export default component.exports